$(document).ready(function () {
    //Burger menu
    $('.js-show-mobile-nav').click(function () {
        $(this).toggleClass('open');
        $('.js-heading-links').toggleClass('active');
        $('.js-mobile-nav')./*slideToggle().*/toggleClass('open');

        // Add dark class when "open" but return to original dark state on close
        var header = $('.js-header');

        if ($(this).hasClass('open')) {
            // Mobile nav is opening
            if (header.hasClass('dark')) {
                header.data('was-dark', true);
            } else {
                header.data('was-dark', false);
            }
            header.removeClass('dark');
        } else {
            // Mobile nav is closing
            if (header.data('was-dark')) {
                header.addClass('dark');
            }
        }
    });

    // Show/hide mobile header menu
    var headerNav = $('.js-expand-mobile-nav');
    headerNav.click(function (e) {

        var sub_menu = $(this).next('.js-mobile-sub-menu');
        var symbol = $(this).find('.js-mobile-expand-symbol');

        symbol.html(function (i, text) {
            return text === "<span>+</span>" ? "<span>-</span>" : "<span>+</span>";
        });
        symbol.toggleClass('expanded');

        //sub_menu.slideToggle();
        sub_menu.toggleClass('open');
        //sub_menu.toggleClass('active');
    });

    $(".js-parent-menu-item").on('click', function () {

        var dropdown_symbol = $(this).find('.js-dropdown-symbol');

        $(this).toggleClass("active");
        $(".js-heading-links").toggleClass("active");
        dropdown_symbol.toggleClass("minus");
        dropdown_symbol.html(function (i, text) {
            return text === "<span>+</span>" ? "<span>-</span>" : "<span>+</span>";
        });

        var header = $('header');

        if ($(this).hasClass('active')) {
            if (header.hasClass('dark')) {
                header.addClass('was-dark');
            }

            header.removeClass('dark');
        } else {
            if (header.hasClass('was-dark')) {
                header.addClass('dark').removeClass('was-dark');
            }
        }

    });

    /*$('.js-hover-image').on('mousemove', function (e) {
        var $this = $(this);
        var rect = this.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var deltaX = (centerX - x) * 0.05; // Adjust the factor here to control the movement sensitivity
        var deltaY = (centerY - y) * 0.05; // Adjust the factor here to control the movement sensitivity

        // Ensure the displacement is capped at 10px in any direction
        var moveX = Math.max(-10, Math.min(10, deltaX));
        var moveY = Math.max(-10, Math.min(10, deltaY));

        $this.find('img').css('transform', 'scale(1.2) translate(' + moveX + 'px, ' + moveY + 'px)');
    }).on('mouseleave', function () {
        $(this).find('img').css('transform', 'scale(1.2) translate(0, 0)'); // Reset position when the mouse leaves
    });*/

});


